import { render, staticRenderFns } from "./commonGoodsClass.vue?vue&type=template&id=0b0f1fbd"
import script from "./commonGoodsClass.vue?vue&type=script&lang=ts"
export * from "./commonGoodsClass.vue?vue&type=script&lang=ts"
import style0 from "./commonGoodsClass.vue?vue&type=style&index=0&id=0b0f1fbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports